"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobError = void 0;
class JobError extends Error {
    constructor(message, params) {
        super(message);
        this.params = params !== null && params !== void 0 ? params : {};
    }
}
exports.JobError = JobError;
//# sourceMappingURL=error.js.map